import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { FILE } from '../constants';
import type { FileElement } from '../types';

export const isFile = isElementType<FileElement>(FILE);
